module.exports = __webpack_public_path__ + "img/burn-original.72821108.png";